module.exports = __webpack_public_path__ + "static/hero_2-408f0a5a8831e6943902359812cffe2e.jpg";